<template>
  <div class="us_app">
    <section class="user_section">
      <div class="title jc">
        <h2>내 처방 상세 정보</h2>
      </div>

      <article class="view">
        <div class="table_list">
          <h3 class="tb_title">내 처방 정보</h3>
          <table class="write">
            <colgroup>
              <col width="200" />
              <col width="30%" />
              <col width="200" />
              <col width="30%" />
            </colgroup>
            <tbody>
              <tr>
                <th>처방명</th>
                <td>
                  <span>{{myPrescibeInfo.prescribe_nm}}</span>
                </td>
              </tr>
              <tr>
                <th>출전</th>
                <td><span>{{myPrescibeInfo.prescribe_source}} </span></td>
              </tr>
              <tr>
                <th>카테고리</th>
                <td><span>{{myPrescibeInfo.prescribe_category_nm}} </span></td>
              </tr>
              <tr>
                <th>메모</th>
                <td><span>{{myPrescibeInfo.prescribe_note}} </span></td>
              </tr>
              <tr>
                <th>등록일자</th>
                <td>
                  <span>{{formatDate_YYYYMMDD(myPrescibeInfo.prescribe_dt)}}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="table_list">
          <h3 class="tb_title">내 처방 약재</h3>
          <table class="write">
            <colgroup>
              <col width="25%" />
              <col width="25%" />
              <col width="25%" />
              <col width="25%" />
            </colgroup>
            <thead>
              <th class="ac">약재명</th>
              <th class="ac">이명</th>
              <th class="ac">설명</th>
              <th class="ac">첩량</th>
            </thead>
            <tbody>
              <tr v-for="(item, index) in medicineList" :key="index">
                <td class="ac"><span>{{ item.med_hrb_nm }}</span></td>
                <td class="ac"><span>{{ item.med_alias }}</span></td>
                <td class="ac"><span>{{ item.med_prfm  }}</span></td>
                <td class="ac">
                  <span>{{ item.medicine_use_qnty }}</span>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="bottom_box">
            <button class="btn btn_md btn_darkbrown" @click="fn_move_list_page">
              목록
            </button> 
            <div class="btn_box">
                  <button class="btn btn_md btn_brown" @click="fn_move_mod_page">수정</button>
                  <button class="btn btn_md btn_red" @click="fn_delte_my_prescribe">삭제</button>
            </div> 
          </div>
        </div>
      </article>
    </section>
    <alert-modal 
          :id="'alert'"
          :text="showAlertMsg" 
          :btnRight="'확인'" 
          :oneBtn="false"
          :isShow="showAlert"
          :className="'btn_brown'"
          :closeEventValue="true"
          @closeEvent="oncCloseEvent"
          v-on:update:showSetting="fn_showSet"
      />
  </div>
</template>

<script>

import axios from 'axios'
import commonUtil from "@/mixin/commonUtil";
import AlertModal from "@/modal/common/alertModal.vue"
import alertutill from "@/mixin/alertModalUtill";

export default {
  components: {
    AlertModal
  },
  mixins: [commonUtil,alertutill],
  data() {
    return {
      my_prescribe_seq : '',
      clinic_doctor_id : '',
      myPrescibeInfo : {},
      medicineList : []     
    };
  },
  created(){
    this.my_prescribe_seq = this.$store.getters['detailSearchInfo/getSearchId'];
    this.clinic_doctor_id = this.$store.getters['clinicDoctorInfo/getClinicDoctorId'];
  },
  mounted(){
    this.fn_search();
  },
  methods: {
    fn_search(){

          //환자seq 정보 셋팅
          let param = new Object();
          param.my_prescribe_seq = this.my_prescribe_seq;
          param.clinic_doctor_id = this.clinic_doctor_id;

          //환자정보 상세조회
          axios
              .post("/api/user/myPrescribe/getMyPrescribeDetail", param)
              .then((res) => {
                  console.log("@@@@ res : %o",res);
                  this.myPrescibeInfo = res.data.myPrescribeInfo;
                  this.medicineList = res.data.myPrescribeMedicineList;
              })
              .catch((err) => console.log(err));
              
      },
      fn_move_list_page(){
          this.$store.dispatch('detailSearchInfo/setSearchId', ''); 
          this.$router.push("/mypage/myPrescribeList");
      },
      fn_move_mod_page(){
          this.$store.dispatch('detailSearchInfo/setStatus', 'M'); 
          this.$router.push("/mypage/MyPrescribeWrite");
      },
      fn_delte_my_prescribe(){
        let param = new Object();
          param.my_prescribe_seq = this.my_prescribe_seq;
          param.clinic_doctor_id = this.clinic_doctor_id;

          //환자정보 상세조회
          axios
              .post("/api/user/myPrescribe/deleteMyPrescribe", param)
              .then((res) => {
                  let msg = "삭제되었습니다.";
                  this.fn_open_alert_close(msg);
              })
              .catch((err) => console.log(err));
      },
      oncCloseEvent(){
          this.fn_move_list_page();
      }
  },
};
</script>
